import { getUser } from '../services/authService';
import { UserRoles } from '../constants/userRoles';
import { Permissions } from '../config/permissions';

export const checkPermissions = (key = '', multiKeys = []) => {
	let role = getUser()?.role || null;
	if (!role) {
		return true;
	}
	if (!Permissions[role] && !Permissions[role]?.length) {
		return true;
	}

	if (role === UserRoles.SuperAdmin) {
		return true;
	}

	if (multiKeys?.length) {
		let isHide = false;
		multiKeys.forEach((resp) => {
			return Permissions[role].forEach((permissionKey) => {
				if (permissionKey.toLocaleLowerCase() === resp.toLocaleLowerCase()) {
					isHide = true;
				}
			});
		});
		return isHide;
	}

	if (key) {
		return !!Permissions[role].find(
			(permissionKey) =>
				permissionKey.toLocaleLowerCase() === key.toLocaleLowerCase()
		);
	}

	return true;
};
